import React from 'react';
import classes from './CustomCalendar.module.css';
import Calendar from 'react-calendar';
import moment from 'moment/moment';

type Props = {
  weekMode?: boolean;
  selectedRange?: string[];
  selectedDate: Date;
  minDate?: Date;
  highlightedDates: string[];
  onSelectDay: (value: Date) => void;
  format?: string;
};
const CustomCalendar: React.FC<Props> = ({
  selectedDate,
  selectedRange,
  weekMode,
  minDate,
  onSelectDay,
  highlightedDates,
  format,
}) => {
  const [dateFormat] = React.useState<string>(format ?? 'DD.MM.yyyy');
  const lang = localStorage.getItem('lang') || 'en';

  return (
    <div className={classes.container}>
      <Calendar
        value={new Date(selectedDate)}
        minDate={minDate ?? new Date()}
        locale={lang}
        tileContent={(props) => {
          if (props.view === 'month') {
            const momentDate = moment(props.date);
            const formattedDate = momentDate.format(dateFormat);
            return (
              <div
                className={
                  props.date.getMonth() !== props.activeStartDate.getMonth()
                    ? classes.neighboringMonth
                    : (
                        weekMode && selectedRange
                          ? selectedRange.includes(momentDate.format())
                          : momentDate.isSame(moment(selectedDate), 'days')
                      )
                    ? classes.selectedTile
                    : highlightedDates.includes(formattedDate)
                    ? classes.customCalendarTileBold
                    : classes.customCalendarTile
                }
              >
                {props.date.getMonth() === props.activeStartDate.getMonth() &&
                  !moment(props.date).isSame(selectedDate) &&
                  highlightedDates.includes(formattedDate) && <div className={classes.blueDot} />}
                {props.date.getDate()}
              </div>
            );
          }
          return <></>;
        }}
        onClickDay={(date) => onSelectDay(date)}
        className="custom-calendar"
      />
    </div>
  );
};

export { CustomCalendar };
